import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaLink } from 'react-icons/fa';

const LinkUI = ({
  questionId,
  answerLinks,
  setAnswerLinks,
  handleInputChange,
  MySwal,
  colors
}) => {
  const { t } = useTranslation();
  const hasLink = answerLinks[questionId];
  
  // Function to handle link input
  const handleLinkInput = (questionId, link) => {
    setAnswerLinks(prev => ({
      ...prev,
      [questionId]: link
    }));
  };
  
  if (hasLink) {
    return (
      <div className="mt-3 mb-0">
        <div className="card">
          <div className="card-body p-3">
            <div className="d-flex align-items-center">
              <FaLink className="me-2" size={18} color="#6c757d" />
              <div className="flex-grow-1">
                <h6 className="mb-0">{t('providedLink', { ns: 'labels' })}</h6>
                <a href={answerLinks[questionId]} target="_blank" rel="noopener noreferrer" className="text-break">
                  {answerLinks[questionId]}
                </a>
              </div>
              <button 
                type="button" 
                className="btn btn-sm btn-outline-danger ms-2"
                onClick={() => {
                  // Remove link
                  setAnswerLinks(prev => {
                    const newLinks = {...prev};
                    delete newLinks[questionId];
                    return newLinks;
                  });
                }}
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="mt-3 mb-0">
      <div className="input-group">
        <span className="input-group-text">
          <FaLink />
        </span>
        <input 
          type="url" 
          className="form-control" 
          placeholder={t('enterLink', { ns: 'labels' })}
          id={`link-input-${questionId}`}
        />
        <button 
          className="btn btn-outline-primary" 
          type="button"
          onClick={() => {
            const linkInput = document.getElementById(`link-input-${questionId}`);
            const link = linkInput.value.trim();
            
            // Basic URL validation
            if (link && (link.startsWith('http://') || link.startsWith('https://'))) {
              handleLinkInput(questionId, link);
              
              // Show success message
              MySwal.fire({
                title: t('linkAdded', { ns: 'labels' }),
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
              });
            } else {
              // Show validation error
              MySwal.fire({
                title: t('enterValidUrl', { ns: 'labels' }),
                icon: 'warning',
                confirmButtonColor: colors?.warning || '#ffc107'
              });
            }
          }}
        >
          {t('save', { ns: 'labels' })}
        </button>
      </div>
    </div>
  );
};

export default LinkUI; 